import { STM } from '../context/types';

export const ar_maStatements: STM[] = [
  {
    "id": 1,
    "valueKey": "samen1",
    "title": "نحن نعمل غالبًا معًا",
    "title_360_leadership": "يشجع العمل الجماعي",
    "title_360_workenv": "نحن نعمل غالبًا معًا",
    "preferredType": "leadership"
  },
  {
    "id": 2,
    "valueKey": "samen2",
    "title": "الفريق أهم من الفرد",
    "title_360_leadership": "يعزز نجاح الفريق قبل نجاحه",
    "title_360_workenv": "الفريق أهم من الفرد",
    "preferredType": "workenv"
  },
  {
    "id": 3,
    "valueKey": "samen3",
    "title": "نبذل قصارى جهدنا من أجل الفريق",
    "title_360_leadership": "يشارك مع فريقه",
    "title_360_workenv": "نبذل قصارى جهدنا من أجل الفريق",
    "preferredType": "leadership"
  },
  {
    "id": 4,
    "valueKey": "conf1",
    "title": "لا نعبر عن رأينا إذا كان ذلك قد يؤدي إلى صراع",
    "title_360_leadership": "لا يعبر عن رأيه إذا كان ذلك قد يؤدي إلى صراع",
    "title_360_workenv": "لا نعبر عن رأينا إذا كان ذلك قد يؤدي إلى صراع",
    "preferredType": "workenv"
  },
  {
    "id": 5,
    "valueKey": "conf2",
    "title": "نبذل قصارى جهدنا لتجنب النزاعات",
    "title_360_leadership": "يبذل قصارى جهده لتجنب النزاعات",
    "title_360_workenv": "نبذل قصارى جهدنا لتجنب النزاعات",
    "preferredType": "leadership"
  },
  {
    "id": 6,
    "valueKey": "conf3",
    "title": "نحن نحترم القواعد والمعايير",
    "title_360_leadership": "يتأكد من احترام القواعد والمعايير",
    "title_360_workenv": "نحن نحترم القواعد والمعايير",
    "preferredType": "workenv"
  },
  {
    "id": 7,
    "valueKey": "erken1",
    "title": "الزملاء يظهرون الاحترام لبعضهم البعض",
    "title_360_leadership": "يضمن بيئة حيث نحترم بعضنا البعض",
    "title_360_workenv": "الزملاء يظهرون الاحترام لبعضهم البعض",
    "preferredType": "workenv"
  },
  {
    "id": 8,
    "valueKey": "erken2",
    "title": "نتلقى التقدير لما نقوم به",
    "title_360_leadership": "يمنح التقدير لما نفعله",
    "title_360_workenv": "نتلقى التقدير لما نقوم به",
    "preferredType": "workenv"
  },
  {
    "id": 9,
    "valueKey": "erken3",
    "title": "يُقدر الجهد",
    "title_360_leadership": "يقدر الجهد المبذول",
    "title_360_workenv": "يُقدر الجهد",
    "preferredType": "leadership"
  },
  {
    "id": 10,
    "valueKey": "zorg1",
    "title": "نحن متعاطفون ومحترمون",
    "title_360_leadership": "يكون متعاطفًا ومحترمًا",
    "title_360_workenv": "نحن متعاطفون ومحترمون",
    "preferredType": "leadership"
  },
  {
    "id": 11,
    "valueKey": "zorg2",
    "title": "نتأكد من أن الجميع يشعرون بالراحة",
    "title_360_leadership": "يعزز جوًا يشعر فيه الجميع بالراحة",
    "title_360_workenv": "نتأكد من أن الجميع يشعرون بالراحة",
    "preferredType": "workenv"
  },
  {
    "id": 12,
    "valueKey": "zorg3",
    "title": "نساعد الزملاء، العملاء و/أو الشركاء الآخرين",
    "title_360_leadership": "يعزز مناخ التعاون",
    "title_360_workenv": "نساعد الزملاء، العملاء و/أو الشركاء الآخرين",
    "preferredType": "leadership"
  },
  {
    "id": 13,
    "valueKey": "gelijk1",
    "title": "كل شخص لديه فرص متساوية",
    "title_360_leadership": "يعامل الجميع بشكل عادل",
    "title_360_workenv": "كل شخص لديه فرص متساوية",
    "preferredType": "workenv"
  },
  {
    "id": 14,
    "valueKey": "gelijk2",
    "title": "عمرك، أصلك أو جنسك لا يهم",
    "title_360_leadership": "لا يميز بناءً على العمر أو الأصل أو الجنس",
    "title_360_workenv": "عمرك، أصلك أو جنسك لا يُحدث الفرق",
    "preferredType": "workenv"
  },
  {
    "id": 15,
    "valueKey": "gelijk3",
    "title": "نحكم على أفعالنا، وليس على شخصياتنا",
    "title_360_leadership": "يقيمنا بناءً على أفعالنا، وليس شخصياتنا",
    "title_360_workenv": "نحكم على أفعالنا، وليس على شخصياتنا",
    "preferredType": "leadership"
  },
  {
    "id": 16,
    "valueKey": "zelfsturing1",
    "title": "لدينا حرية تقرير ما نقوم به",
    "title_360_leadership": "يتركني أتصرف بنفسي",
    "title_360_workenv": "لدينا حرية تقرير ما نقوم به",
    "preferredType": "workenv"
  },
  {
    "id": 17,
    "valueKey": "zelfsturing2",
    "title": "يمكننا تحديد طريقتنا الخاصة في العمل",
    "title_360_leadership": "يتركني أحدد طريقتي الخاصة في العمل",
    "title_360_workenv": "يمكننا تحديد طريقتنا الخاصة في العمل",
    "preferredType": "leadership"
  },
  {
    "id": 18,
    "valueKey": "zelfsturing3",
    "title": "يمكن لكل شخص التخطيط لأنشطته بنفسه",
    "title_360_leadership": "يسمح لي بتحديد جدول أعمالي الخاص",
    "title_360_workenv": "يمكن لكل شخص التخطيط لأنشطته بنفسه",
    "preferredType": "workenv"
  },
  {
    "id": 19,
    "valueKey": "macht1",
    "title": "يمكنني التأثير على سلوك الآخرين",
    "title_360_leadership": "يؤثر على عملي",
    "preferredType": "leadership"
  },
  {
    "id": 20,
    "valueKey": "macht2",
    "title": "أنا من يقول ما يجب القيام به",
    "title_360_leadership": "يقول ما يجب القيام به",
    "preferredType": "leadership"
  },
  {
    "id": 21,
    "valueKey": "macht3",
    "title": "أنا من يقرر ما يحدث",
    "title_360_leadership": "يقرر ما يجب القيام به",
    "preferredType": "disabled"
  },
  {
    "id": 22,
    "valueKey": "voorspelbaar1",
    "title": "هناك هيكلية وانتظام",
    "title_360_leadership": "يشجع على الهيكلية والانتظام",
    "title_360_workenv": "هناك هيكلية وانتظام",
    "preferredType": "workenv"
  },
  {
    "id": 23,
    "valueKey": "voorspelbaar2",
    "title": "تجري الأمور عمومًا كما هو مخطط لها",
    "title_360_leadership": "يتأكد من اتباع الخطة",
    "title_360_workenv": "تجري الأمور عمومًا كما هو مخطط لها",
    "preferredType": "leadership"
  },
  {
    "id": 24,
    "valueKey": "voorspelbaar3",
    "title": "نحافظ على التقاليد (القيم، الأفكار، العادات)",
    "title_360_leadership": "يضمن احترام التقاليد (القيم، الأفكار، العادات)",
    "title_360_workenv": "نحافظ على التقاليد (القيم، الأفكار، العادات)",
    "preferredType": "workenv"
  },
  {
    "id": 25,
    "valueKey": "prestatie1",
    "title": "يمكننا إظهار أفضل ما لدينا",
    "title_360_leadership": "يشجعني على تقديم أفضل ما لدي",
    "title_360_workenv": "يمكننا إظهار أفضل ما لدينا",
    "preferredType": "leadership"
  },
  {
    "id": 26,
    "valueKey": "prestatie2",
    "title": "يمكننا إظهار إمكاناتنا",
    "title_360_leadership": "يشجعنا على إظهار ما يمكننا فعله",
    "title_360_workenv": "يمكننا إظهار إمكاناتنا",
    "preferredType": "workenv"
  },
  {
    "id": 27,
    "valueKey": "prestatie3",
    "title": "يمكننا التفوق في ما نقوم به",
    "title_360_leadership": "يشجع على التفوق في ما نقوم به",
    "title_360_workenv": "يمكننا التفوق في ما نقوم به",
    "preferredType": "workenv"
  },
  {
    "id": 28,
    "valueKey": "zelfontplooi1",
    "title": "يمكننا الاستمرار في التعلم",
    "title_360_leadership": "يشجع على التعلم المستمر",
    "title_360_workenv": "يمكننا الاستمرار في التعلم",
    "preferredType": "workenv"
  },
  {
    "id": 29,
    "valueKey": "zelfontplooi2",
    "title": "يمكننا تعميق معرفتنا",
    "title_360_leadership": "يشجعني على تعميق مهاراتي",
    "title_360_workenv": "يمكننا تعميق معرفتنا",
    "preferredType": "leadership"
  },
  {
    "id": 30,
    "valueKey": "zelfontplooi3",
    "title": "يمكننا الاستمرار في التطور",
    "title_360_leadership": "يساعد الآخرين على التطور",
    "title_360_workenv": "يمكننا الاستمرار في التطور",
    "preferredType": "workenv"
  },
  {
    "id": 31,
    "valueKey": "duurzaam1",
    "title": "نقدم عملاً عالي الجودة",
    "title_360_leadership": "يتأكد من أن الفريق يقدم عملاً عالي الجودة",
    "title_360_workenv": "نقدم عملاً عالي الجودة",
    "preferredType": "leadership"
  },
  {
    "id": 32,
    "valueKey": "duurzaam2",
    "title": "نحترم العملاء والعلاقات الأخرى",
    "title_360_leadership": "يشجع الفريق على احترام العملاء والعلاقات الأخرى",
    "title_360_workenv": "نحترم العملاء والعلاقات الأخرى",
    "preferredType": "workenv"
  },
  {
    "id": 33,
    "valueKey": "duurzaam3",
    "title": "نهتم بالناس، السلامة والبيئة",
    "title_360_leadership": "يتأكد من مراعاة الأفراد، السلامة والبيئة",
    "title_360_workenv": "نراعي الأفراد، السلامة والبيئة",
    "preferredType": "workenv"
  },
  {
    "id": 34,
    "valueKey": "integriteit1",
    "title": "نحن نتحمل المسؤولية عن أفعالنا",
    "title_360_leadership": "يتأكد من أننا نتحمل المسؤولية عن أفعالنا",
    "title_360_workenv": "نحن نتحمل المسؤولية عن أفعالنا",
    "preferredType": "workenv"
  },
  {
    "id": 35,
    "valueKey": "integriteit2",
    "title": "نكون صادقين",
    "title_360_leadership": "يكون صادقًا",
    "title_360_workenv": "نكون صادقين",
    "preferredType": "workenv"
  },
  {
    "id": 36,
    "valueKey": "integriteit3",
    "title": "نعالج المعلومات الشخصية والسرية بعناية",
    "title_360_leadership": "يعالج المعلومات الشخصية والسرية بعناية",
    "title_360_workenv": "نعالج المعلومات الشخصية والسرية بعناية",
    "preferredType": "leadership"
  },
  {
    "id": 37,
    "valueKey": "innovatie1",
    "title": "يمكننا تجربة طرق جديدة للعمل",
    "title_360_leadership": "يشجعنا على تجربة طرق جديدة للعمل",
    "title_360_workenv": "يمكننا تجربة طرق جديدة للعمل",
    "preferredType": "leadership"
  },
  {
    "id": 38,
    "valueKey": "innovatie2",
    "title": "نقوم بالكثير من التجارب الجديدة",
    "title_360_leadership": "يشجع على اكتساب تجارب جديدة",
    "title_360_workenv": "نقوم بالكثير من التجارب الجديدة",
    "preferredType": "workenv"
  },
  {
    "id": 39,
    "valueKey": "innovatie3",
    "title": "يمكننا العثور على تحديات جديدة",
    "title_360_leadership": "يحفزنا على إيجاد تحديات جديدة",
    "title_360_workenv": "يمكننا العثور على تحديات جديدة",
    "preferredType": "leadership"
  },
  {
    "id": 40,
    "valueKey": "daadkracht1",
    "title": "نعمل من تلقاء أنفسنا",
    "title_360_leadership": "يشجع على بدء المهام بأنفسنا",
    "title_360_workenv": "نبدأ العمل من تلقاء أنفسنا",
    "preferredType": "workenv"
  },
  {
    "id": 41,
    "valueKey": "daadkracht2",
    "title": "نحرص على تحقيق النتائج",
    "title_360_leadership": "يتأكد من تحقيق النتائج",
    "title_360_workenv": "نحرص على تحقيق النتائج",
    "preferredType": "leadership"
  },
  {
    "id": 42,
    "valueKey": "daadkracht3",
    "title": "نبذل كل جهد لتحقيق الأهداف المستهدفة",
    "title_360_leadership": "يبذل كل جهد لتحقيق الأهداف المستهدفة",
    "title_360_workenv": "نبذل كل جهد لتحقيق الأهداف المستهدفة",
    "preferredType": "leadership"
  }
];


export const extra360Ar_MaStatements: Omit<STM, 'title'>[] = [
  {
    id: 43,
    valueKey: 'daadkracht4',
    title_360_leadership: 'يتخذ القرارات',
    preferredType: 'leadership',
  },
  {
    id: 44,
    valueKey: 'gelijk4',
    title_360_leadership: 'يحترم ويقدر الاختلافات بين أعضاء الفريق',
    preferredType: 'leadership',
  },
  {
    id: 45,
    valueKey: 'prestatie4',
    title_360_leadership: 'يقدم ملاحظات بناءة',
    preferredType: 'leadership',
  },
];
